import React, { Component } from 'react';
import './Sidebar.css';

class Sidebar extends Component {
    render() {
        return (
            <div className="sidebar-container">
                <div>
                    <div className="sidebar-title">PRESENTATION</div>
                    <div className="sidebar-presentation__content">
                        <img className="sidebar-presentation__content--img" src="/images/presentation.png" />
                        <div className="sidebar-presentation__content--text">
                            Hello ! Moi c'est Mathilde !
                            Passionnée de cuisine et plus particulièrement de pâtisserie, j'ai décidé de créer ce blog afin de vous partager toutes mes bonnes recettes.<br />
                            Retrouvez moi aussi sur Instagram @unzestedegourmandises :)
                        </div>
                    </div>
                </div>
                <div>
                    <div className="sidebar-title">INSTAGRAM</div>
                    <div className="sidebar-instagram__pictures">
                        {/*<a href="{{media.link}}" ng-repeat="media in ctrl.medias">*/}
                            {/*<img ng-src="{{media.images.thumbnail.url}}" />*/}
                        {/*</a>*/}
                    </div>
                    <div className="sidebar-instagram__follow">
                        <a href="https://www.instagram.com/unzestedegourmandises/">
                            <i className="fa fa-instagram"></i>
                            Suivez-moi sur Instagram
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar.js